import { Link } from "react-router-dom";

const cardImages = [
  "https://readdy.ai/api/search-image?query=Single%20premium%20leather%20sneaker%20in%20warm%20caramel%20brown%20tone%20placed%20on%20textured%20cream%20linen%20surface%20soft%20directional%20window%20light%20from%20upper%20left%20clean%20minimal%20product%20photography%20elegant%20shadow%20detail%20refined%20composition%20showing%20suede%20texture%20and%20stitching&width=400&height=533&seq=hero-card-v2-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Rich%20forest%20green%20knit%20sweater%20folded%20neatly%20on%20light%20maple%20wooden%20surface%20soft%20diffused%20natural%20light%20from%20side%20clean%20minimal%20fashion%20product%20photography%20showing%20cable%20knit%20texture%20elegant%20composition%20with%20warm%20neutral%20background&width=400&height=533&seq=hero-card-v2-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20wristwatch%20with%20brushed%20rose%20gold%20case%20and%20taupe%20leather%20strap%20placed%20on%20cream%20linen%20with%20soft%20shadows%20editorial%20luxury%20product%20photography%20clean%20refined%20composition%20soft%20natural%20window%20light&width=400&height=533&seq=hero-card-v2-03&orientation=portrait",
];

const cardPositions = [
  "z-10 -rotate-2",
  "z-20 scale-110 -mt-8",
  "z-10 rotate-2",
];

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden pt-[72px]">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Artistic%20top%20down%20flatlay%20collage%20of%20diverse%20fashion%20products%20including%20rust%20toned%20sneakers%20sage%20green%20sweater%20warm%20brown%20leather%20watch%20and%20ceramic%20accessories%20arranged%20on%20light%20cream%20linen%20surface%20soft%20diffused%20natural%20daylight%20from%20left%20minimal%20scandinavian%20inspired%20editorial%20product%20photography%20clean%20harmonious%20palette%20of%20earthy%20muted%20tones&width=1600&height=1000&seq=hero-bg-v2-2026&orientation=landscape)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/25 to-background-50/60"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-6 flex flex-col items-center text-center">
        <p className="text-xs tracking-[0.3em] uppercase text-foreground-500 mb-6 font-label">Curated Sourcing Intelligence</p>

        <h1 className="font-heading text-[72px] md:text-[96px] font-extrabold leading-[0.9] text-foreground-950">
          itaobuy<br />
          <span className="font-normal italic">sheet</span>
        </h1>

        <p className="mt-6 text-lg md:text-xl text-foreground-600 max-w-[560px] leading-relaxed">
          Discover trending products from a curated China sourcing spreadsheet. Built for dropshipping sellers, resellers, and eCommerce growth.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-foreground-900 text-background-50 text-base font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer group"
          >
            itaobuy sheet
            <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2.5 px-8 py-4 rounded-full border-2 border-foreground-200 text-foreground-800 text-base font-semibold hover:border-foreground-900 hover:text-foreground-950 transition-all duration-300 whitespace-nowrap cursor-pointer group"
          >
            buy it now
            <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
          </a>
        </div>

        <div className="mt-16 flex items-center gap-2 text-xs text-foreground-500">
          <span>Trusted by sellers in</span>
          <span className="font-semibold text-foreground-700">UK</span>
          <span className="text-foreground-300">·</span>
          <span className="font-semibold text-foreground-700">USA</span>
          <span className="text-foreground-300">·</span>
          <span className="font-semibold text-foreground-700">EU</span>
        </div>

        <div className="mt-20 grid grid-cols-3 gap-0 w-full max-w-[720px]">
          {cardImages.map((src, i) => (
            <div
              key={i}
              className={`relative bg-background-50 rounded-2xl overflow-hidden border border-background-200/50 ${cardPositions[i]}`}
              style={{ aspectRatio: "3/4" }}
            >
              <img
                src={src}
                alt="Product preview"
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <Link
          to="/itaobuy-sheet-guide"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent-100 text-accent-800 text-sm font-medium hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-article-line"></i>
          Read Full Guide
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="absolute bottom-8 right-10 z-10 hidden md:block">
        <a
          href="#categories"
          className="flex flex-col items-center gap-1 text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer"
        >
          <span className="text-[10px] tracking-widest uppercase">Scroll</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}